"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BUDGET_START_DAY = exports.DEFAULT_FIXED_EXPENSE_CATEGORY = exports.MATCH_BY_TYPE = exports.ENRICHMENT_INPUT_TYPES = exports.EXPENSE_FIELD_NAME = exports.VARIABLE_EXPENSE_CATEGORY = exports.ECONOMY_EXPENSE_CATEGORY = exports.ENVELOPES_DEFAULT_DETAILS = exports.WEEK_TIMEFRAME = exports.DAY_FORMAT = exports.VARIABLE_INCOME_ENVELOPE_ID = exports.VARIABLE_ENVELOPE_ID = void 0;
exports.VARIABLE_ENVELOPE_ID = 'variable';
exports.VARIABLE_INCOME_ENVELOPE_ID = 'variableIncome';
exports.DAY_FORMAT = 'YYYY-MM-DD';
exports.WEEK_TIMEFRAME = {
    PAST: 'past',
    CURRENT: 'current',
    FUTURE: 'future',
};
exports.ENVELOPES_DEFAULT_DETAILS = {
    rollingCredit: {
        expense: 'אשראי מתגלגל',
        businessName: 'אשראי מתגלגל',
    },
};
exports.ECONOMY_EXPENSE_CATEGORY = 'כלכלה';
exports.VARIABLE_EXPENSE_CATEGORY = 'משתנות';
exports.EXPENSE_FIELD_NAME = 'expense';
exports.ENRICHMENT_INPUT_TYPES = {
    TRANSACTION_ID: 'transactionId',
    BUSINESS_NAME: 'businessName',
};
exports.MATCH_BY_TYPE = {
    TRANSACTION_ID: 'transactionId',
    BUSINESS_NAME: 'businessName',
    PAYMENT_APP_ADDRESSEE: 'paymentAppAddressee',
    EXPENSE: 'expense',
};
exports.DEFAULT_FIXED_EXPENSE_CATEGORY = 'אחר';
exports.DEFAULT_BUDGET_START_DAY = 1;
//# sourceMappingURL=consts.js.map